import {
  GetSimilarItemsSettingsArgs,
  UpdateSimilarItemsSettingsPayload,
} from 'src/components-bl/SimilarItems/Actions/types';
import * as mapper from './mapper';
import * as builder from './builder';
import { SimilarItemsSettingsTypes } from '../types';
import { ApiServiceBase } from '../api-service-base';

export class SimilarItemsGeneralSettings extends ApiServiceBase {
  constructor() {
    super('shops');
  }

  private getUrl({ shopId, variantId }: GetSimilarItemsSettingsArgs): string {
    return `${this.serviceBaseUri}/${shopId}/syte-products/similar-items/general-settings${
      variantId ? `?variantId=${variantId}` : ''
    }`;
  }

  async get({
    shopId,
    variantId,
  }: GetSimilarItemsSettingsArgs): Promise<SimilarItemsSettingsTypes.SimilarItemsSettings> {
    const url = this.getUrl({ shopId, variantId });
    const response = await this.httpService.get({ url });
    return mapper.similarItemsSettingsResponse(response);
  }

  async update({
    shopId,
    variantId,
    ...payload
  }: UpdateSimilarItemsSettingsPayload): Promise<SimilarItemsSettingsTypes.SimilarItemsSettings> {
    const url = this.getUrl({ shopId, variantId });

    const data = builder.buildSimilarItemsSettingsPayload(payload);
    const response = await this.httpService.patch({ url, data });
    return mapper.similarItemsSettingsResponse(response);
  }
}
